import React, { useEffect, useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axiosInstance from "../axiosInstance";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BackendHeader from "../component/BackendHeader";
import CustomerSelectEdit from "./CustomerSelectEdit";
import * as general from '../libs/general';
import { API_URL_All } from "../api";
import { useDispatch } from "react-redux";
import { setFilters } from "../redux/filterReducer";


const API_URL = `${API_URL_All}/api/import-orders`; // API URL chuẩn

const EditOrder = () => {
  const { id } = useParams(); // Lấy ID từ URL
  const navigate = useNavigate(); // Điều hướng sau khi cập nhật thành công
  const [order, setOrder] = useState(null); // State lưu dữ liệu đơn hàng
  const [units, setUnits] = useState([]);
  const [lines, setLines] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [rateData, setRateData] = useState([]); // Thêm state cho rateData

  const dispatch = useDispatch();
  useEffect(() => {
    // Retrieve filters from sessionStorage on component mount
    const storedFilters = sessionStorage.getItem('filters');
    if (storedFilters) {
      const parsedFilters = JSON.parse(storedFilters);
      // Set state based on stored filters


      // Dispatch to Redux with the loaded filters
      dispatch(setFilters(parsedFilters));
      sessionStorage.setItem('filters', JSON.stringify(parsedFilters));
    }

  }, [dispatch]);


  useEffect(() => {
    if (id) {
      fetchOrderDetails(id);
    }
  }, [id]);

  const fetchOrderDetails = async (orderId) => {
    try {
      const response = await axiosInstance.get(`${API_URL}/${orderId}`);
      setOrder(response.data);
    } catch (error) {
      console.error("Lỗi khi lấy dữ liệu:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchWithCheck = async (url) => {
          const response = await fetch(url, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
              Accept: "application/json",
            },
          });
          if (!response.ok) {
            console.error(`Error fetching ${url}:`, response.statusText);
            return []; // Return empty array to prevent JSON parse error
          }
          return response.json();
        };

        // Thêm URL mới cho rateData
        const [unitData, lineData, statusData, rateData] = await Promise.all([
          fetchWithCheck(`${API_URL_All}/api/model-details/by-model/2`),
          fetchWithCheck(`${API_URL_All}/api/model-details/by-model/1`),
          fetchWithCheck(`${API_URL_All}/api/model-details/by-model/3`),
          fetchWithCheck(`${API_URL_All}/api/model-details/by-model/4`), // Fetch rateData
        ]);

        setUnits(unitData);
        setLines(lineData);
        setStatuses(statusData);
        setRateData(rateData); // Lưu rateData vào state
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await fetch(`${API_URL_All}/api/users/all`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
            Accept: "application/json",
          },
        });
        if (!response.ok) {
          throw new Error("Lỗi khi lấy danh sách khách hàng");
        }
        const data = await response.json();
        setCustomers(data);
      } catch (error) {
        console.error("Lỗi API:", error);
      }
    };

    fetchCustomers();
  }, []);

  // Validation Schema
  const validationSchema = Yup.object({
    name: Yup.string().required("Vui lòng nhập Tên sản phẩm"),
    lineId: Yup.string().required("Vui lòng nhập Line"),

    locked: Yup.boolean(), // Thêm validation cho checkbox locked
    // packageUnitValue: Yup.number()
    //   .typeError("Vui lòng nhập Khối lượng")
    //   .required("Khối lượng là bắt buộc"),
    insurancePrice: Yup.number()
      .typeError("Vui lòng nhập Giá bảo hiểm")
      .required("Giá bảo hiểm là bắt buộc"),
  });

  const handleSubmit = async (values) => {

    try {
      const response = await axiosInstance.put(`${API_URL}/admin/${id}`, values, {
        headers: { "Content-Type": "application/json" },
      });

      toast.success("Cập nhật thành công đơn hàng!", { position: "top-right" });
      navigate("/quan-li-don-hang");
    } catch (error) {
      toast.error(error.response.data);
    }
  };

  if (!order) {
    return <p>Đang tải dữ liệu...</p>;
  }

  return (
    <div>
      <BackendHeader />
      <div className="container my-2">
        <h2 className="text-center mb-4">Cập nhật đơn hàng</h2>
        <Formik
          initialValues={{
            name: order.name || "",
            userId: order.user?.id || "",
            packageNumbers: order.packageNumbers || "0",
            packageUnitValue: order.packageUnitValue || "0",
            insurancePrice: order.insurancePrice || "0",
            supplementaryFee: order.supplementaryFee || "0",
            shippingMethod: order.shippingMethod || "",
            cnShippingCode: order.cnShippingCode || "",
            vnShippingCode: order.vnShippingCode || "",
            lineId: order.lineId?.id || "",
            packageUnitM3: order.packageUnitM3 || "",
            statusId: order.statusId?.id || "",
            statusRateId: order.statusRateId?.id || "",
            locked: order.locked || false,
            note: order.note || ""
          }}
          enableReinitialize={true} // Cập nhật dữ liệu form khi có đơn hàng từ API
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, errors }) => (
            <Form className="row g-3 fw-bold">

              <CustomerSelectEdit
                customers={customers}
                selectedUserId={values.userId} // Truyền giá trị userId hiện tại
                setFieldValue={setFieldValue}
                error={errors.userId}
                isDisabled={values.locked}
              />

              <div className="col-md-6"></div>

              <div className="col-md-6">
                <label className="form-label">Line <span className="text-danger">*</span></label>
                <Field as="select" className="form-control" name="lineId" disabled={values.locked}>
                  <option value="">--Chọn--</option>
                  {lines.map((line) => (
                    <option key={line.id} value={line.id}>
                      {line.name}
                    </option>
                  ))}
                </Field>
                <ErrorMessage name="lineId" component="div" className="text-danger" />
              </div>

              <div className="col-md-6">
                <label className="form-label">Tên sản phẩm<span className="text-danger"> *</span></label>
                <Field type="text" className="form-control" name="name" disabled={values.locked} />
                <ErrorMessage name="name" component="div" className="text-danger" />
              </div>

              <div className="col-md-6">
                <label className="form-label">Mã vận đơn Trung Quốc</label>
                <Field type="text" className="form-control" name="cnShippingCode" disabled={values.locked} />
              </div>

              <div className="col-md-6">
                <label className="form-label">Mã vận đơn Việt Nam</label>
                <Field type="text" className="form-control" name="vnShippingCode" disabled={values.locked} />
              </div>

             

              <div className="col-md-3">
                <label className="form-label">Số lượng kiện hàng</label>
                <Field type="number" className="form-control" name="packageNumbers" disabled={values.locked} min="0"/>
              </div>
 <div className="col-md-2">
                <label className="form-label">M3 <span className="text-danger"></span></label>
                <Field
                  type="number"
                  className="form-control"
                  name="packageUnitM3"
                  disabled={values.locked}
                  min="0"
                  step="any"
                />
                <ErrorMessage name="packageUnitM3" component="div" className="text-danger" />
              </div>
              <div className="col-md-2">
                <label className="form-label">Khối lượng  <span className="text-danger"></span></label>
                <Field type="number" className="form-control" name="packageUnitValue" disabled={values.locked} min="0" step="any"/>
                <ErrorMessage name="packageUnitValue" component="div" className="text-danger" />
              </div>

              <div className="col-md-2">
                <label className="form-label">Giá bảo hiểm <span className="text-danger">*</span></label>
                <Field type="number" className="form-control" name="insurancePrice" disabled={values.locked} min="0" step="any"/>
                <ErrorMessage name="insurancePrice" component="div" className="text-danger" />
              </div>

              <div className="col-md-2">
                <label className="form-label">Phụ phí phát sinh</label>
                <Field type="number" className="form-control" name="supplementaryFee" disabled={values.locked} min="0" step="any"/>
              </div>

              <div className="col-md-6">
                <label className="form-label">Phương thức lấy hàng</label>
                <Field as="textarea" className="form-control" name="shippingMethod" disabled={values.locked} />
              </div>

              <div className="col-md-6">
                <label className="form-label">Lưu trình</label>
                <Field as="select" className="form-control" name="statusId" disabled={values.locked}>
                  {/* <option value="">--Chọn--</option> */}
                  {statuses.map((status) => (
                    <option key={status.id} value={status.id}>
                      {status.name}
                    </option>
                  ))}
                </Field>
              </div>

              <div className="col-md-6">
                <label className="form-label">Đối soát</label>
                <Field as="select" className="form-control" name="statusRateId" disabled={values.locked}>
                  {/* <option value="">--Chọn--</option> */}
                  {rateData.map((rate) => (
                    <option key={rate.id} value={rate.id}>{rate.name}</option>
                  ))}
                </Field>
              </div>

              <div className="col-md-6">
                <label className="form-check-label">Khóa đơn hàng</label>
                <br />
                <Field
                  type="checkbox"
                  className="form-check-input"
                  name="locked"
                  checked={values.locked}
                  onChange={() => setFieldValue("locked", !values.locked)} // Đảo giá trị khi checkbox được chọn
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Ghi chú</label>
                <Field
                  as="textarea"
                  className="form-control"
                  name="note"
                  disabled={values.locked} // Disable if locked
                />

              </div>
              <div className="col-12 text-center">
                <button type="submit" className="btn btn-success px-5 py-2 me-3">Cập nhật</button>
                              <button className="btn btn-secondary py-2 me-3" onClick={() => navigate(general.getBackLink('/quan-li-don-hang')) }>Quay lại</button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default EditOrder;
